import React from 'react';

const HeaderCell = ({ elements, filter, rowspan = 1, height = '1.5rem' }) => {
  const highlightItems = (id) => {

    if (id) {
      let elements = document.querySelectorAll(`[name='${id}']:not(.highlighted)`);

      if (elements) {
        elements.forEach(element => {
          element.style.backgroundColor = element.highlighted ?  element.style.backgroundColor : '#0289CA';
        });
      }
    }
  };

  const resetHighlight = (id) => {
    let elements = document.querySelectorAll(`[name='${id}']:not(.highlighted)`);
    if (elements) {
      elements.forEach(element => {
        element.style.backgroundColor = element.highlighted ?  element.style.backgroundColor : 'transparent';
      });
    }
  };

  const onHover = (id) => {
    highlightItems(id);
  };

  const onMouseOut = (id) => {
    resetHighlight(id);
  };

  return (
    <div rowSpan={rowspan}>
      {elements.filter(filter || (x => x)).map((item) => (
        <div
					style={{ height: height, lineHeight: height }}
					key={item.id}
					name={item.id}
					className={"multi-row border"}
          onMouseEnter={() => onHover(item.id)}
					onMouseOut={() => onMouseOut(item.id)}
				>
					{item.value}
				</div>
      ))}
    </div>
  );
};

export default HeaderCell;
